import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/axiosConfig';
import './Login.css';

const COMPANY_ADDRESS = [
  'B-531, Money Plant High Street, Opp BSNL Office,',
  'Godrej Garden City Jagatpur Road, Ahmedabad, Gujarat, 382470.',
];

const COMPANY_CONTACT = {
  phone: '+91 99793 63351',
  email: 'shivambuildcare@gmail.com',
};

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await api.post('/login', {
        username,
        password: password
      });

      if (response.data.success) {
        localStorage.setItem('isLoggedIn', 'true');
        navigate('/home');
      } else {
        setError('Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <aside className="login-brand">
        <div className="login-brand-center">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo.png`}
            alt="Shivam Buildcare logo"
            className="login-brand-logo"
          />
          <h1 className="login-brand-name">Shivam Buildcare</h1>
        </div>
      </aside>

      <main className="login-panel">
        <div className="login-panel-content">
          <div className="login-box">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="login-username">Username</label>
                <input
                  id="login-username"
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={isLoading}
                  autoComplete="username"
                />
              </div>
              <div className="form-group">
                <label htmlFor="login-password">Password</label>
                <input
                  id="login-password"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                  autoComplete="current-password"
                />
              </div>
              {error && <div className="error-message">{error}</div>}
              <button
                type="submit"
                className="login-button-main"
                disabled={isLoading}
              >
                {isLoading ? 'Logging in...' : 'Login'}
              </button>
            </form>
          </div>
        </div>

        <footer className="login-address">
          <p className="login-address-name">Shivam Buildcare</p>
          {COMPANY_ADDRESS.map((line) => (
            <p key={line}>{line}</p>
          ))}
          <p>{COMPANY_CONTACT.phone}</p>
          <p>{COMPANY_CONTACT.email}</p>
          <div className="login-meta">
            <p>Copyright © 2026 Shivam Buildcare. All rights reserved.</p>
            <p>Created By: Rajan Kambaliya</p>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default Login;
